import { getRouteProviderTypes } from './routesApi';
import { ProviderType } from '../../components/common/ObjectTypes';
import { filter_page_size } from '../apiUtils';

export const loadProviderTypes = async (
  keycloak_token: string,
  page_offset: number,
  providerTypesSearchInput: any,
  providerTypes: ProviderType[],
): Promise<[ProviderType[], number, Error | null]> => {
  let total_provider_types = 0;
  try {
    const query = {
      limit: filter_page_size,
      offset: page_offset,
      search: providerTypesSearchInput,
      search_fields: 'name',
      ordering: 'name',
      previous:
        process.env.REACT_APP_BASE_URL_LOCAL +
        '/v2/integrations/types/?is_provider=true&pager=limit&limit=' +
        filter_page_size +
        '&offset=' +
        (page_offset - filter_page_size),
      next:
        process.env.REACT_APP_BASE_URL_LOCAL +
        '/v2/integrations/types/?is_provider=true&pager=limit&limit=' +
        filter_page_size +
        '&offset=' +
        (page_offset + filter_page_size),
    };
    const temp = await getRouteProviderTypes(keycloak_token, query);
    const new_array: ProviderType[] = providerTypes.concat(temp.results);
    const duplicates_removed: ProviderType[] = Array.from(
      new Set(new_array.map((obj) => obj.id)),
    ).map((id) => {
      return new_array.find((obj) => obj.id === id)!;
    });
    const alphabetized = duplicates_removed.sort((a, b) =>
      a.name.localeCompare(b.name),
    );
    if (providerTypesSearchInput.length === 0)
      total_provider_types = temp.count;
    return [alphabetized, total_provider_types, null];
  } catch (err: any) {
    console.log(err);
    return [[], 0, err];
  }
};
